// ⚠️  GENERATED — do not edit. Run `npm run inferrex:generate` to regenerate.

import type { LucideIcon } from 'lucide-react';
import {
  Activity,
  Archive,
  ArrowRightLeft,
  BadgeCheck,
  Ban,
  BarChart3,
  BellRing,
  Boxes,
  Brain,
  Building,
  Building2,
  Cable,
  CalendarDays,
  CheckCheck,
  ChevronDown,
  Clock,
  Coins,
  Contact,
  Cpu,
  CreditCard,
  Database,
  DatabaseBackup,
  Download,
  Eye,
  FileCheck2,
  Flag,
  Gauge,
  Gem,
  GitBranch,
  GitCompare,
  GitPullRequestArrow,
  Globe,
  Handshake,
  HardDrive,
  HeartPulse,
  HelpCircle,
  History,
  Inbox,
  Key,
  KeyRound,
  LayoutDashboard,
  Library,
  LifeBuoy,
  Link2,
  ListChecks,
  Lock,
  Menu,
  MessageCircle,
  MessageSquareWarning,
  MessagesSquare,
  MousePointerClick,
  Package,
  PackageCheck,
  Pause,
  PenLine,
  Pencil,
  Percent,
  Play,
  Plug,
  Plus,
  Radar,
  RefreshCcw,
  Repeat2,
  Rocket,
  RotateCcw,
  Route,
  Scale,
  ScrollText,
  Search,
  Send,
  Settings,
  Settings2,
  Shapes,
  Shield,
  ShieldAlert,
  ShieldCheck,
  SlidersHorizontal,
  Sparkles,
  Table,
  Tag,
  Timer,
  ToggleRight,
  Trash2,
  TrendingUp,
  Undo2,
  UserCog,
  Users,
  Webhook,
  Wifi,
  Workflow,
  Wrench,
  X,
  Zap,
} from 'lucide-react';

/** Icon name → lucide component, derived from every referenced name in the tree. */
export const ICON_MAP: Record<string, LucideIcon> = {
  Activity,
  Archive,
  ArrowRightLeft,
  BadgeCheck,
  Ban,
  BarChart3,
  BellRing,
  Boxes,
  Brain,
  Building,
  Building2,
  Cable,
  CalendarDays,
  CheckCheck,
  ChevronDown,
  Clock,
  Coins,
  Contact,
  Cpu,
  CreditCard,
  Database,
  DatabaseBackup,
  Download,
  Eye,
  FileCheck2,
  Flag,
  Gauge,
  Gem,
  GitBranch,
  GitCompare,
  GitPullRequestArrow,
  Globe,
  Handshake,
  HardDrive,
  HeartPulse,
  HelpCircle,
  History,
  Inbox,
  Key,
  KeyRound,
  LayoutDashboard,
  Library,
  LifeBuoy,
  Link2,
  ListChecks,
  Lock,
  Menu,
  MessageCircle,
  MessageSquareWarning,
  MessagesSquare,
  MousePointerClick,
  Package,
  PackageCheck,
  Pause,
  PenLine,
  Pencil,
  Percent,
  Play,
  Plug,
  Plus,
  Radar,
  RefreshCcw,
  Repeat2,
  Rocket,
  RotateCcw,
  Route,
  Scale,
  ScrollText,
  Search,
  Send,
  Settings,
  Settings2,
  Shapes,
  Shield,
  ShieldAlert,
  ShieldCheck,
  SlidersHorizontal,
  Sparkles,
  Table,
  Tag,
  Timer,
  ToggleRight,
  Trash2,
  TrendingUp,
  Undo2,
  UserCog,
  Users,
  Webhook,
  Wifi,
  Workflow,
  Wrench,
  X,
  Zap,
};
